// extracted by mini-css-extract-plugin
export default {"span":"Homepage_span__7Gcdc"};